import type { Zone } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useCallback } from 'react'
import { useQuery } from 'react-query'
import useHomeType from './useHomeType'

export const GET_ZONES = `/api/list/zones`

type UseZonesResponse = {
  isLoading: boolean
  zones: Zone[]
  fetchZones: () => void
}

const useZones = (): UseZonesResponse => {
  const { isPro, features } = useHomeType()

  const isZonesEnabled = isPro && features?.zones?.enabled

  const { isLoading, data, refetch } = useQuery(
    'zones',
    () => getJSON({ url: GET_ZONES }),
    { enabled: isZonesEnabled }
  )

  // React Query v3's refetch() bypasses the 'enabled' option
  const fetchZones = useCallback(() => {
    if (isZonesEnabled) {
      refetch()
    }
  }, [isZonesEnabled, refetch])

  return {
    isLoading,
    zones: data?.result || [],
    fetchZones
  }
}

export default useZones
